import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { GateWay } from '../gateway.model';

export enum GateWayActionTypes {
  ReadGatewayList = '[GateWay] Read Gateway List',
  UpsertGatewayList = '[GateWay] Upsert Gateway',
  ReadGatewayListFail = '[GateWay] Read Gateway List Fail',
  AddGateway = '[GateWay] Add Gateway',
  UpdateGateway = '[GateWay] Update Gateway',
  DeleteGateway = '[GateWay] Delete Gateway',
  UpgradeGateway = '[GateWay] Upgrade Gateway',
  UpgradeGatewaySuccess = '[GateWay] Upgrade Gateway Success',
  UpgradeGatewayFail = '[GateWay] Upgrade Gateway Fail',
}

export class ReadGatewayList implements Action {
  readonly type = GateWayActionTypes.ReadGatewayList;

  constructor(public payload: any = null) {}
}
export class UpsertGatewayList implements Action {
  readonly type = GateWayActionTypes.UpsertGatewayList;

  constructor(public payload: any) {}
}
export class ReadGatewayListFail implements Action {
  readonly type = GateWayActionTypes.ReadGatewayListFail;

  constructor(public payload: any = null) {}
}
export class AddGateway implements Action {
  readonly type = GateWayActionTypes.AddGateway;

  constructor(public payload: any = null) {}
}
export class UpdateGateway implements Action {
  readonly type = GateWayActionTypes.UpdateGateway;

  constructor(public payload: any = null) {}
}
export class DeleteGateway implements Action {
  readonly type = GateWayActionTypes.DeleteGateway;

  constructor(public payload: any = null) {}
}
export class UpgradeGateway implements Action {
  readonly type = GateWayActionTypes.UpgradeGateway;

  constructor(public payload: any = null) {}
}
export class UpgradeGatewaySuccess implements Action {
  readonly type = GateWayActionTypes.UpgradeGatewaySuccess;

  constructor(public payload: any = null) {}
}
export class UpgradeGatewayFail implements Action {
  readonly type = GateWayActionTypes.UpgradeGatewayFail;

  constructor(public payload: any = null) {}
}

export type GateWayActions =
ReadGatewayList
 | UpsertGatewayList
 | ReadGatewayListFail
 | AddGateway
 | UpdateGateway
 | DeleteGateway
 | UpgradeGateway
 | UpgradeGatewaySuccess
 | UpgradeGatewayFail
